import { Box, Button, SkeletonText, Table, TableContainer, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";

// import DeleteIcon from "@/assets/DeleteIcon";
import { COLORS } from "@/common/constants";
import Pagination from "../Layouts/Pagination";
import { getEmailTypeLabel } from "@/data/emailType";

const TABLE_COLUMNS = [
    "Subject",
    "Recipients",
    "Created",
    "Email Type",
    "Action",
];

const TableInspectionEmails = ({
    dataList,
    isLoading,
    handlePreview,
    // handleResend,
    // handleDelete,
    currentPageSize,
    handleChangePageSize,
    handleChangePageNumber,
    currentPageNumber,
    totalPageNumber,
    hasNextPage,
}: any) => {
    const renderRows = () => {
        if (isLoading) {
            return (
                <Tr>
                    <Td colSpan={5}>
                        <SkeletonText mt='4' noOfLines={4} spacing='4' skeletonHeight='3' />
                    </Td>
                </Tr>
            );
        }

        if (!dataList || dataList.length === 0) {
            return (
                <Tr>
                    <Td colSpan={5} textAlign="center">Data not found</Td>
                </Tr>
            );
        }

        return dataList.map((item: any) => (
            <Tr key={item.id}>
                <Td maxWidth="250px" whiteSpace="normal" wordBreak="break-word">{item.subject || '-'}</Td>
                <Td maxWidth="300px" whiteSpace="normal" wordBreak="break-word">
                    <div style={{ fontSize: '12px', lineHeight: '1.6' }}>
                        {item.from && <div><span style={{ fontWeight: 'bold' }}>From:</span> {item.from}</div>}
                        {item.to && <div><span style={{ fontWeight: 'bold' }}>To:</span> {item.to}</div>}
                        {item.cc && <div><span style={{ fontWeight: 'bold' }}>Cc:</span> {item.cc}</div>}
                        {item.bcc && <div><span style={{ fontWeight: 'bold' }}>Bcc:</span> {item.bcc}</div>}
                        {!item.from && !item.to && !item.cc && !item.bcc && <span>-</span>}
                    </div>
                </Td>
                <Td>{item.created ? new Date(item.created).toLocaleString() : '-'}</Td>
                <Td>{getEmailTypeLabel(item.emailType)}</Td>
                <Td>
                    <div style={{ display: 'flex', cursor: 'pointer', gap: 8, justifyContent: 'center' }}>
                        <Button
                            size="sm"
                            variant="outline"
                            borderColor={COLORS.PRIMARY}
                            color={COLORS.PRIMARY}
                            borderRadius={6}
                            onClick={() => handlePreview(item)}
                            _hover={{ backgroundColor: COLORS.HIGHLIGHT }}
                        >
                            Preview
                        </Button>
                        {/* <Button 
                            size="sm"
                            backgroundColor={COLORS.PRIMARY}
                            color="#fff"
                            borderRadius={6}
                            onClick={() => handleResend(item.id)}
                            _hover={{ opacity: 0.9 }}
                            isDisabled={false}
                        >
                            Re-send
                        </Button> */}
                        {/* <DeleteIcon onClick={() => handleDelete(item.id)} /> */}
                    </div>
                </Td>
            </Tr>
        ));
    };

    return (
        <TableContainer bgColor="#fff" borderRadius="13">
            <Box overflowX="auto">
                <Table variant='simple'>
                    <Thead>
                        <Tr>
                            {TABLE_COLUMNS.map((header) => (
                                <Th
                                    key={header}
                                    color={COLORS.TABLE_HEADER.FOREGROUND}
                                    backgroundColor={COLORS.TABLE_HEADER.BACKGROUND}
                                    textTransform="none"
                                    fontSize={14}
                                    textAlign={header === 'Action' ? 'center' : 'left'}
                                >
                                    {header}
                                </Th>
                            ))}
                        </Tr>
                    </Thead>
                    <Tbody>
                        {renderRows()}
                    </Tbody>
                </Table>
            </Box>
            <Pagination
                currentPageSize={currentPageSize}
                currentPageNumber={currentPageNumber}
                totalPageNumber={totalPageNumber}
                handleChangePageSize={handleChangePageSize}
                handleChangePageNumber={handleChangePageNumber}
                hasNextPage={hasNextPage}
            />
        </TableContainer>
    );
};

export default TableInspectionEmails;
